export enum AppFeatures {
  dcConnections = 'dcConnections',
  incidents = 'incidents',
  ipManagement = 'ipManagement',
  manualAgreements = 'manualAgreements',
  myInvoices = 'myInvoices',
  myLines = 'myLines',
  myOrders = 'myOrders',
  postalCodeCheck = 'postalCodeCheck',
  quotation = 'quotation',
  rackSpace = 'rackSpace',
  userManagement = 'userManagement',
  wdm = 'wdm',
}
